<template>
  <div v-if="posts.results.length" class="striped">
    <section id="press-releases" class="container news">
      <ModalsShare
        data-testid="news-section-share"
        :showing="isShowingShareMenu"
        :share-url="shareUrl"
        :title="shareTitle"
        analytics-prefix="CompanyPage"
        @update:showing="isShowingShareMenu = $event"
      />
      <header>
        <h2 class="font-semibold text-xl lg_text-2xl mb-4">Press Releases</h2>
      </header>
      <ul class="space-y-7">
        <CompaniesNewsFeedPost
          v-for="post in posts.results"
          :key="post.id"
          :post="post"
          @on-item-clicked="trackNewsItemClicked"
          @on-share-clicked="handleShareClick"
        />
      </ul>
      <LoadingSpinner v-if="posts.loading" class="my-8" />
      <VButton
        v-else-if="posts.results.length && posts.next"
        class="mx-auto block mt-5"
        aria-label="Newsfeed Pagination"
        data-testid="newsfeed-load-more"
        @click="handleSeeMoreClick"
        >See More</VButton
      >
    </section>
  </div>
</template>

<script lang="ts" setup>
import type { Ref } from 'vue'
import type { Post } from '@/entities/post'
import type { NewsfeedPost } from '@/entities/newsfeedPost'
import type { DeepReadonly } from 'vue'

defineProps({
  posts: {
    type: Object as () => DeepReadonly<{
      loading: boolean
      next: string | null
      results: NewsfeedPost[]
    }>,
    required: true,
  },
})

const emit = defineEmits(['see-more'])

const { $analytics } = useNuxtApp()

const isShowingShareMenu: Ref<boolean> = ref(false)
const shareUrl: Ref<string> = ref('')
const shareTitle: Ref<string> = ref('')

function trackNewsItemClicked({ title, id }: Post) {
  $analytics.track('companyProfileNewsPostSelected', {
    newsTitle: title,
    newsId: id,
  })
}

function handleShareClick({ title, url_slug }: Post) {
  isShowingShareMenu.value = true

  shareUrl.value = `${window.location.origin}/press-releases/${url_slug ?? ''}`
  shareTitle.value = title ?? ''
}

function handleSeeMoreClick(): void {
  emit('see-more')
  $analytics.track('companyProfileSeeMoreNewsSelected')
}
</script>
